export const tts = {
    ru: async () => [
        (await import("./tts-get-noises.ru.js")).default, 
        (await import("./tts-get-voices.ru.js")).default, 
        (await import("./tts-post-synthesize.ru.js")).default
    ],
    en: async () => [
        (await import("./tts-get-noises.en.js")).default, 
        (await import("./tts-get-voices.en.js")).default, 
        (await import("./tts-post-synthesize.en.js")).default
    ]
}
